import { render, staticRenderFns } from "./page-order-care.vue?vue&type=template&id=22ee96ed&scoped=true"
import script from "./page-order-care.vue?vue&type=script&lang=js"
export * from "./page-order-care.vue?vue&type=script&lang=js"
import style0 from "./page-order-care.vue?vue&type=style&index=0&id=22ee96ed&prod&lang=scss&scoped=true"
import style1 from "./page-order-care.vue?vue&type=style&index=1&id=22ee96ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee96ed",
  null
  
)

export default component.exports